import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react"
import { toast } from 'react-toastify';
import { Grid, TextField, Button } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { URLS } from "../../helpers/URLS";
import useAxios from "../../helpers/Hooks/useAxios";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import JobDescriptionModal, { splitSkills, excerpt } from './JobDescriptionModal';
import ConfirmJobStatus from './ConfirmJobStatus';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import Tooltip from '@mui/material/Tooltip';
import SkeletonLoader from "../../loaders/Skeleton";
import NoData from "../../loaders/NoData";
import Chip from '@mui/material/Chip';
import * as moment from "moment";
import PaginationGlobal from "../TablePagination.js/PaginationGlobal";
import './recruiter.css'
import '../../assets/scss/tables.scss';


const JobJD = () => {

    const { fetchData } = useAxios();

    const [loadSkeleton, setLoadSkeleton] = useState(true);

    const [isStatusModel, setIsStatusModel] = useState(false);

    const [jds, setJds] = useState([]);

    const [pageNumber, setPageNumber] = useState(1);

    const [btnText, setBtnText] = useState("Save");

    /* the job whose description is being read, if any */
    const [viewingJob, setViewingJob] = useState(null);

    /* the job waiting on a close/reopen confirmation */
    const [statusJob, setStatusJob] = useState(null);

    const [data, setData] = useState({
        jobID: '',
        jobTitle: '',
        experienceFrom: '',
        experienceTo: '',
        skills: '',
        expiredOn: null,
        requirements: '',
        _id: '',
        numberOfRounds: ''
    })

    const modelHandle = () => {
        if (isStatusModel) {
            resetForm()
        }
        setIsStatusModel(!isStatusModel)
    }

    const handleOnChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const resetForm = () => {
        setData({
            jobID: '',
            jobTitle: '',
            experienceFrom: '',
            experienceTo: '',
            skills: '',
            expiredOn: null,
            requirements: '',
            numberOfRounds: '',
            _id: ''
        })
    }

    const editModal = (updateJob) => {
        setData({
            jobTitle: updateJob.jobTitle,
            experienceFrom: updateJob.experienceFrom,
            experienceTo: updateJob.experienceTo,
            skills: updateJob.skills,
            expiredOn: updateJob.expiredOn,
            requirements: updateJob.requirements,
            numberOfRounds: updateJob.numberOfRounds,
            _id: updateJob._id
        });
    }

    useEffect(() => {
        GetJobJds();
    }, [])

    const GetJobJds = async () => {
        setLoadSkeleton(true);
        const { data } = await fetchData({ url: URLS.getJobs, method: 'get' })
        setJds(data || []);
        setLoadSkeleton(false)
    }

    const getPageNo = (data) => {
        setPageNumber(data)
    }

    const isJobActive = (job) =>
        job.isActive !== false && !moment(job.expiredOn).isBefore(new Date(), 'day');

    const changeJobStatus = async () => {
        const response = await fetchData({
            url: URLS.setJobStatus,
            method: 'put',
            body: { jobId: statusJob._id, isActive: statusJob.isActive === false }
        });

        if (response?.success === false) {
            toast.error(response?.message || 'Could not change the job status');
            return;
        }

        toast.success(response?.message || 'Job status updated');
        setStatusJob(null);
        GetJobJds();
    };

    const countPerPage = 10;

    return (
        <div className="wh-table">
            <div className='wh-toolbar'>
                <h4 className="title">Jobs</h4>
                <div className="ms-auto">
                    <Button type="button" variant="contained" onClick={(e) => { modelHandle(resetForm()) }}>Add Job</Button>
                </div>
            </div>
            <div className=''>
                <div className="table-responsive wh-table-shell">
                    {loadSkeleton ? <SkeletonLoader /> :
                        (jds.length > 0 ?
                            <div>
                                <table className="table">
                                    <thead>
                                        <tr style={{ whiteSpace: 'nowrap' }}>
                                            <th scope="col">Job ID</th>
                                            <th scope="col">Job Title</th>
                                            <th scope="col">Experience</th>
                                            <th scope="col">Skills</th>
                                            <th scope="col">Requirements</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">No. of Rounds</th>
                                            <th scope="col">Created On</th>
                                            <th scope="col">Expires On</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {jds && jds.slice((pageNumber - 1) * countPerPage,
                                            pageNumber * countPerPage).map((s, subIndex) =>
                                                <tr key={s._id}>
                                                    <td scope="row">{s.jobID} </td>
                                                    <td>{s.jobTitle}</td>
                                                    <td className='text-nowrap'>
                                                        {s.experienceFrom} &ndash; {s.experienceTo}
                                                        {s.experienceTo > 1 ? " Years" : " Year"}
                                                    </td>
                                                    <td>
                                                        {splitSkills(s.skills).length > 0
                                                            ? <span className='wh-cell-clamp' title={splitSkills(s.skills).join(', ')}>
                                                                {splitSkills(s.skills).join(', ')}
                                                            </span>
                                                            : '--'}
                                                    </td>
                                                    <td>
                                                        {s.requirements
                                                            ? <div className='wh-excerpt'>
                                                                <span className='wh-excerpt-text'>{excerpt(s.requirements)}</span>
                                                                <Tooltip title="View full job description" placement="top" arrow>
                                                                    <IconButton onClick={() => setViewingJob(s)}>
                                                                        <VisibilityOutlinedIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                            : '--'}
                                                    </td>
                                                    <td>{isJobActive(s)
                                                        ? <Chip label="Active" color="success" size="small" />
                                                        : <Chip label="Inactive" color="error" size="small" />}</td>
                                                    <td>{s.numberOfRounds}</td>
                                                    <td className='text-nowrap'>{s.createdDate ? moment(s.createdDate).format("DD MMM YYYY") : '--'}</td>
                                                    <td className='text-nowrap'>{moment(s.expiredOn).format("DD MMM YYYY")}</td>
                                                    <td>
                                                        <Tooltip title="Edit job" placement="top" arrow>
                                                            <IconButton onClick={() => {
                                                                editModal(s)
                                                                modelHandle()
                                                                setBtnText("Update")
                                                            }}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        {s.isActive === false
                                                            ? <Tooltip title="Reopen job" placement="top" arrow>
                                                                <IconButton onClick={() => setStatusJob(s)}>
                                                                    <RestartAltOutlinedIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            : <Tooltip title="Close job" placement="top" arrow>
                                                                <IconButton className="wh-danger" onClick={() => setStatusJob(s)}>
                                                                    <BlockOutlinedIcon />
                                                                </IconButton>
                                                            </Tooltip>}
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>

                                </table>
                                {
                                    jds && jds.length > 0 ? <div> <PaginationGlobal count={Math.ceil(jds.length / countPerPage)}
                                        pageNumber={pageNumber} func={getPageNo} /> </div> : ""
                                }
                            </div>
                            : <NoData />
                        )
                    }
                </div>
                <Modal size="lg" show={isStatusModel} onHide={modelHandle} backdrop="static" className="wh-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>{data._id ? "Update" : "Add"} A Job</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='work-report-section'>
                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <TextField fullWidth label="Job Title" value={data.jobTitle} onChange={handleOnChange} name={'jobTitle'} required size="small" />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField fullWidth label="Experience From" value={data.experienceFrom} onChange={handleOnChange} name={'experienceFrom'} required size="small" />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField fullWidth label="Experience To" value={data.experienceTo} onChange={handleOnChange} name={'experienceTo'} required size="small" />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField fullWidth label="Number of Rounds" value={data.numberOfRounds} onChange={handleOnChange} name={'numberOfRounds'} required size="small" />
                                </Grid>
                                <Grid item xs={6} >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Expire On"
                                            inputFormat="DD/MM/YYYY"
                                            value={data.expiredOn}
                                            minDate={moment().toDate()}
                                            onChange={(date) => setData({ ...data, expiredOn: date })}
                                            renderInput={(params) => <TextField {...params} fullWidth required
                                            />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} >
                                    <TextField fullWidth label="Skills" value={data.skills} onChange={handleOnChange} name={'skills'} required size="small" />
                                </Grid>
                                <Grid item xs={12} >
                                    <label className="form-label">Job Description</label>
                                    <CKEditor id="requirements" name="requirements"
                                        config={{ placeholder: "Add Job Description" }}
                                        editor={ClassicEditor} data={data.requirements}
                                        onChange={(event, editor) => {
                                            const editordata = editor.getData()
                                            setData({ ...data, requirements: editordata })
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="contained" color="inherit" onClick={modelHandle} className="me-3">Close</Button>
                        <Button onClick={async (e) => {
                            const {
                                jobTitle,
                                experienceFrom,
                                experienceTo,
                                skills,
                                expiredOn,
                                requirements,
                                numberOfRounds
                            } = data;
                            let payload = {};
                            if (!data._id) {
                                payload = {
                                    jobTitle,
                                    experienceFrom,
                                    experienceTo,
                                    skills,
                                    expiredOn,
                                    requirements,
                                    numberOfRounds: parseInt(numberOfRounds)
                                }
                            } else {
                                payload = data;
                            }
                            const { status, message } = await fetchData({ url: URLS.addOrUpdateJob, method: 'post', body: payload })
                            if (status === 200) {
                                toast.success(message);
                                GetJobJds();
                                modelHandle()
                            }
                            else {
                                toast.error(message, 'error')
                            }
                        }} variant="contained">
                            {data._id ? "Update" : "Save"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            <JobDescriptionModal job={viewingJob} onClose={() => setViewingJob(null)} />

            <ConfirmJobStatus job={statusJob} onClose={() => setStatusJob(null)} onConfirm={changeJobStatus} />
        </div>
    )
}

export default JobJD;

